import React from 'react';
import PropTypes from 'prop-types';

class Delayed extends React.Component {

  constructor(props) {
    super(props);
    this.state = {hidden : true};
  }

  componentDidMount() {
    this.timeout = setTimeout(() => {
      this.setState({hidden: false});
    }, this.props.wait);
  }

  componentWillUnmount() {
    if(this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  render() {
    if(this.state.wait <= 0) {
      return this.props.children;
    }
    return this.state.hidden ? '' : this.props.children;
  }
}

Delayed.propTypes = {
  wait: PropTypes.number.isRequired
};

Delayed.defaultProps = {wait: 200}
export default Delayed;
